import { useCallback } from 'react';
import { useState, useEffect, useContext } from 'react';
import userService from '../services/users.js'
import { GeneralContext } from '../context/GeneralContext'
import { useTranslation } from "react-i18next";


export const useUser = () => {

    const { user, setUser } = useContext(GeneralContext);
    const [state, setState] = useState({ loading: null, error: false, loginError: false, tipoError: null });
    const { i18n } = useTranslation();

     useEffect(() => {
        if (user == null) {
            
            userService.isLogged()
                .then(user => {
                    if(user.username !== ''){
                        setUser(user)
                    }
                })
                .catch(err => {
                    setState({ loading: false, error: true })
                })
         }
    }, [])

    const switchUserLanguage = (l) => {
        let newUser = {...user}
        if (!newUser) {
            newUser = {
                language: l
            }
        } else {
            newUser.language = l;
        }
        setUser(newUser);
    }
    
    const login = useCallback((username, password) => { //Todo investigar useCallBack
        setState({ loading: true, error: false, loginError: false, tipoError: null })
        userService.login({ username, password })
            .then(user => {
                setState({ loading: false, error: false })
                user.language = i18nToApiLanguage(i18n.language)
                setUser(user)
            })
            .catch(err => {
                setState({ loading: false, error: true, loginError: true, tipoError: err?.response?.data?.CodeMessage })
            })
    }, [setUser])

    const logout = useCallback(() => {
        setState({ loading: true, error: false, loginError: false, tipoError: null })
        userService.logout()
            .then(() => {
                setState({ loading: false, error: false })
                setUser(null)
            })
            .catch(err => {
                setState({ loading: false, error: true, loginError: true, tipoError: err.response?.data })
            })
    }, [setUser])

    const getURLs = () => userService.getURLs();

    function i18nToApiLanguage(language) {
        switch (language) {
            case "es":
                return "es-ES";
            case "en":
                return "EN";
            case "ca":
                return "ca-ES";
            case "ga":
                return "gl-ES";
            case "eu":
                return "eu-ES";
            case "va":
                return "ca-ES-valencia"
            default:
                return "es-ES";
        }
    }

    return {
        user,
        login,
        logout,
        getURLs,
        switchUserLanguage,
        isLogged: Boolean(user && user.usuario),
        isLoginLoading: state.loading,
        hasLoginError: state.error,
        loginError: state.loginError,
        errorType: state.tipoError
    };
}
